module.exports = "<app-scaffold>\n  <basic-page-header title=\"Frequently Asked Questions\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <section ng-include=\"ctrl.deployment.faq\"></section>\n    </div>\n  </div>\n</app-scaffold>\n"


//////////////////
// WEBPACK FOOTER
// ./src/partials/faq.html
// module id = 309
// module chunks = 0